export const GameResultEnum = {
  None: "None",
  Won: "Won",
  Lost: "Lost",
  Tied: "Tied",
};

export const GameStatusForSchedule = {
  scheduled: "scheduled",
  forfeit: "forfeit",
  // cancelled: "cancelled",
};
